import { render, staticRenderFns } from "./ownGoodsLibrary.vue?vue&type=template&id=0541458f&scoped=true"
import script from "./ownGoodsLibrary.vue?vue&type=script&lang=js"
export * from "./ownGoodsLibrary.vue?vue&type=script&lang=js"
import style0 from "./ownGoodsLibrary.vue?vue&type=style&index=0&id=0541458f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0541458f",
  null
  
)

export default component.exports